import React from 'react';
import { Link } from 'react-router-dom';

// Bootstrap Components.
import { Badge, Card, CardBody, CardText, Container } from 'reactstrap';

import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown';

// Custom Components.
import BetaSignupCard from '../components/BetaSignupCard';
import BetaRoleCards from '../components/BetaRoleCards';
import ShareButton from '../components/ShareButton';

import roadmapImage from '../images/Roadmap.png';

import '@leenguyen/react-flip-clock-countdown/dist/index.css';

function MainPageContent({ showAlert = () => null }) {
    return (
        <div className="page-content pb-5">            
            <section className="page-band page-band--hero section-shell">
                <Container fluid className="px-0">
                    <div className="row g-3 g-xl-4 align-items-stretch">
                        <div className="col-12 col-xl-8 d-flex order-1">
                            <div className="d-flex flex-column justify-content-between gap-3 w-100 hero-frame surface-elevated p-3 p-lg-4 shadow rounded-3 border border-primary-orange-subtle">
                                <div className="d-flex flex-column gap-3">
                                    <h1 className="display-5 text-light text-uppercase fw-normal anton-regular mb-0 sfb-title">
                                        Battles. Bars. Bragging&nbsp;Rights.
                                    </h1>

                                    <CardText className="fs-4 text-secondary mb-0 hero-subtitle">
                                        <span className="text-primary-orange-emphasis">Spitface Battles</span>
                                        &nbsp;brings structured competition to online rap battles. Battlers compete, judges score, and audience participation is built into every battle. SFB is where skill and reputation reflect quality and consistency over time.
                                    </CardText>
                                </div>

                                <div className="d-flex flex-wrap align-items-end justify-content-center justify-content-md-start gap-2">
                                    <a href="#signup-section" className="btn btn-primary btn-lg btn-cta fw-semibold border-2 px-4">
                                        Reserve Your Username
                                    </a>
                                    <ShareButton size="lg" />
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-xl-4 d-flex order-2">
                            <Card className="panel-card w-100 surface-elevated shadow-sm hero-brief">
                                <CardBody className="panel-card-body d-flex flex-column flex-md-row flex-xl-column justify-content-around justify-content-lg-start gap-3">
                                    <div className="d-flex flex-column gap-2">
                                        <div className="d-flex justify-content-between">
                                            <p className="small fw-semibold text-uppercase text-nowrap text-primary-orange-emphasis mb-0">Get In Early</p>
                                            <Badge pill
                                                tag="small"
                                                className="text-uppercase text-secondary border border-primary-orange-subtle bg-transparent"
                                            >Closed Beta</Badge>
                                        </div>
                                        
                                        <h2 className="h4 text-light mb-0">Beta Access Starts Here</h2>
                                        <div className="d-grid gap-2">
                                            <div className="d-flex justify-content-between align-items-start gap-3 border-bottom border-primary-orange-subtle pb-2">
                                                <span className="small text-secondary text-uppercase">Entry</span>
                                                <span className="small fw-semibold text-light text-end">Open - Limited Capacity</span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-start gap-3 border-bottom border-primary-orange-subtle pb-2">
                                                <span className="small text-secondary text-uppercase">Impact</span>
                                                <span className="small fw-semibold text-light text-end">Shape platform systems</span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-start gap-3">
                                                <span className="small text-secondary text-uppercase">Rewards</span>
                                                <span className="small fw-semibold text-light text-end">Tiered & role-based</span>
                                            </div>
                                        </div>
                                        <a href="#beta-roles-section" className="btn btn-cta btn-outline-primary btn-link text-decoration-none fw-semibold my-2">
                                            Explore Beta Roles
                                        </a>
                                    </div>

                                    <div className="my-auto">
                                        <FlipClockCountdown
                                            to={'07/01/2026'}
                                            renderMap={[true, true, false, false]}
                                            labels={['days', 'hours', 'mins', 'secs']}
                                            digitBlockStyle={{ boxShadow: 'var(--sfb-shadow-1)' }}
                                            className="justify-content-center align-self-center bg-darker p-2 rounded-5 permanent-marker-regular flip-clock"
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </Container>
            </section>

            <section id="signup-section" className="page-band section-shell">
                <Container fluid className='px-0'>
                    <div>
                        <div className="section-heading mb-3 d-flex flex-column flex-lg-row justify-content-between align-items-lg-end gap-2">
                            <div>
                                <h2 className="h3 mb-1 text-light text-uppercase londrina-outline-regular">
                                    Reserve Your Username
                                </h2>
                                <p className="mb-0 text-secondary">
                                    Claim your name. Secure your spot. Step to the mic.
                                </p>
                            </div>
                        </div>

                        <div className="row g-4 align-items-stretch">
                            <div className="col-12 col-lg-7 d-flex order-1 order-xl-1">
                                <BetaSignupCard showAlert={showAlert} />
                            </div>

                            <div className="col-12 col-lg-5 d-flex order-2 order-xl-2">
                                <div className="w-100 d-flex flex-column gap-2">
                                    <Card className="panel-card surface-elevated bg-darker-50 shadow-sm">
                                        <CardBody className="panel-card-body">
                                            <p className="small text-uppercase fw-semibold text-primary-orange-emphasis mb-2">How It Works</p>
                                            <ol className="ps-3 mb-0 d-grid gap-2 text-secondary">
                                                <li>Reserve your username</li>
                                                <li>Verify your email</li>
                                                <li>Optionally pick a Beta Role</li>
                                                <li>Wait for beta launch</li>
                                            </ol>
                                        </CardBody>
                                    </Card>

                                    <Card className="panel-card surface-elevated bg-darker-50 shadow-sm">
                                        <CardBody className="panel-card-body">
                                            <p className="small text-uppercase fw-semibold text-primary-orange-emphasis mb-2">
                                                Beta Role Outcomes
                                            </p>
                                            <ol className="ps-3 mb-0 d-grid gap-2 text-secondary">
                                                <li>Progressive premium unlocks</li>
                                                <li>Role specific recognition</li>
                                                <li>Official status given to top performers</li>
                                            </ol>
                                        </CardBody>
                                    </Card>

                                    <Card className="panel-card surface-elevated bg-darker-50 shadow-sm">
                                        <CardBody className="panel-card-body">
                                            <p className="small text-uppercase fw-semibold text-primary-orange-emphasis mb-2">Beta Role Structure</p>
                                            <ol className="ps-3 mb-0 d-grid gap-2 text-secondary">
                                                <li>Beta roles have requirements and limited capacity</li>
                                                <li>Rewards and final status are earned, not guaranteed</li>
                                            </ol>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* <section className="page-band section-shell surface-elevated">
                <div className="section-heading mb-3">
                    <h2 className="h3 mb-1 text-light text-uppercase londrina-outline-regular">Launch Window</h2>
                    <p className="mb-0 text-secondary">Track launch timing and preview what is coming.</p>
                </div>
                <BetaCountDownCard showHeader={false} />
            </section> */}

            <section id="beta-roles-section" className="page-band section-shell">
                <div className="section-heading mb-3 d-flex flex-column flex-lg-row justify-content-between align-items-lg-end gap-2">
                    <div>
                        <h2 className="h3 mb-1 text-light text-uppercase londrina-outline-regular">Pick Your Role</h2>
                        <p className="mb-0 text-secondary">
                            Explore each role. Claim your spot. Earn your legacy
                        </p>
                    </div>
                    <Link to="/beta-roles" className="align-self-sm-start align-self-lg-center btn btn-primary btn-cta border-2 px-4">
                        View Role Details
                    </Link>
                </div>
                <Container fluid className='px-0'>
                    <div className="w-100">
                        <BetaRoleCards />
                    </div>
                </Container>
            </section>

            <section id="beta-roles-section" className="page-band section-shell">
                <div className="section-heading mb-3">
                    <h2 className="h3 mb-1 text-light text-uppercase londrina-outline-regular">
                        Dev Roadmap
                    </h2>
                    <p className="mb-0 text-secondary">
                        Checkout what is planned for SFB
                    </p>
                </div>
                <Container fluid className='px-0'>
                    <div className="text-center">
                        <img fetchpriority="low" src={roadmapImage} alt="Development Roadmap" loading="lazy" decoding="async" className="img-fluid shadow-xs roadmap-image" />
                    </div>
                </Container>
            </section>
        </div>
    )
}

export default MainPageContent;
